<!-- Display the time portion of a date value in a pretty/consistent way -->
<script lang="ts" setup>
    import { computed } from "@vue/reactivity";
    import { getTimeStringParts, isMidnight } from "../lib/DateUtils";

    const props = withDefaults(defineProps<{
            date: Date|string,
            suppressMidnight?: boolean
            militaryTime?: boolean
        }>(), {
            suppressMidnight: true,
            militaryTime: false
        });

    const timeParts = computed(() => 
        getTimeStringParts(props.date, props.militaryTime));

    const showTimestamp = computed(() =>{
        if (!props.date)
            return false;

        if (props.suppressMidnight)
            if (isMidnight(props.date)) 
                return false;

        return true;
    });

</script>

<template>
    <template v-if="showTimestamp && timeParts">
        <template v-if="!militaryTime">
            {{timeParts.time}} <span style="font-size:smaller">{{timeParts.ampm}}</span> ({{timeParts.timeZoneAbbr}})
        </template>
        <template v-if="militaryTime">
            {{timeParts.time}} ({{timeParts.timeZoneAbbr}})
        </template>
    </template>
</template>